import {Text} from "@chakra-ui/react";
import React from "react";

export const EditorParameterName = ({children}) => <Text fontWeight={600}>{children}</Text>;